import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollAnimation = () => {
  const location = useLocation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      const els = document.querySelectorAll(
        '.fade-in:not(.is-visible),.slide-left:not(.is-visible),.slide-right:not(.is-visible),.slide-up:not(.is-visible),.slide-down:not(.is-visible)'
      );

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -20px 0px' }
      );

      els.forEach((el) => observer.observe(el));

      return () => observer.disconnect();
    }, 80);

    return () => clearTimeout(timeout);
  }, [location.pathname]);
};

export default useScrollAnimation;
